export const WHITE_COLOR = '#FFFFFF';

export const BLACK_COLOR = '#000000';
export const DISCLAMERS_COLOR = '#666666';
export const DARK_GREY_COLOR = '#b3b3b3';
export const NORMAL_GREY_COLOR = '#e7e7e7';
export const LIGHT_GREY_COLOR = '#f6f6f6';

export const GREEN_COLOR = '#4CBB17';
export const GREEN_COLOR_1 = '#006837';
export const LINK_COLOR = '#3A4FFF';
export const URL_COLOR = '#808083';
export const RED_COLOR = '#F83E1B';

export const COINS_COLOR = {
	btc: {
		backgroundColor: '#f7941d',
		color: '#fff'
	},
	eth: {
		backgroundColor: '#3e4ea1',
		color: '#fff'
	},
	xrp: {
		backgroundColor: '#414042',
		color: '#fff'
	},
	bch: {
		backgroundColor: '#8dc541',
		color: '#000'
	},
	hex: {
		backgroundColor: '#000000',
		color: '#fff'
	},
	xht: {
		backgroundColor: '#000000',
		color: '#fff'
	},
	xmr: {
		backgroundColor: '#000000',
		color: '#fff'
	},
	dai: {
		backgroundColor: '#000000',
		color: '#fff'
	},
	mkr: {
		backgroundColor: '#000000',
		color: '#fff'
	}
};
